import React from "react";
import Student from "./Student";
import School from "./School";
import Agent from "./Agent";
import { useFormState } from "react-final-form";
import { UserRole } from "../../../../../enums/UserRole";
import ServiceProvider from "./ServiceProvider";
import Support from "./Support";
import Parent from "./Parent";
import Teacher from "./Teacher";

const FormFieldsByRole = () => {
  const { values: user } = useFormState();

  switch (user.role) {
    case UserRole.Agent:
      return <Agent />;
    case UserRole.Parent:
      return <Parent />;
    case UserRole.School:
      return <School />;
    case UserRole.ServiceProvider:
      return <ServiceProvider />;
    case UserRole.Student:
      return <Student />;
    case UserRole.Teacher:
      return <Teacher />;
    case UserRole.Support:
      return <Support />;
    default:
      return null;
  }
};
export default FormFieldsByRole;
